<script>
  // A job that failed, was killed, or was interrupted by a restart.
  import { createEventDispatcher } from "svelte";
  import JobCard from "../UI/JobCard.svelte";
  import IconButton from "../UI/IconButton.svelte";
  import { download, deleteJob } from "../../lib/jobs.js";
  import { formatDateTime } from "../../lib/format.js";

  export let fileId;
  export let filename;
  export let uploadedDateTime;
  export let errorMessage;

  const dispatch = createEventDispatcher();

  async function remove() {
    if (await deleteJob(fileId, filename)) dispatch("changed");
  }

  $: meta = [{ label: "Uploaded", value: formatDateTime(uploadedDateTime) }];
</script>

<JobCard id={fileId} title={filename} status="error" {meta}>
  <svelte:fragment slot="actions">
    <IconButton
      tip="Download input python file"
      icon="fa-code"
      colour="warning"
      onClick={() => download.python(fileId)}
    />
    <IconButton
      tip="Download input excel file"
      icon="fa-file-excel"
      colour="success"
      onClick={() => download.inputExcel(fileId)}
    />
    <IconButton
      tip="Download output log file"
      icon="fa-file-download"
      colour="info"
      onClick={() => download.log(fileId)}
    />
    <IconButton
      tip="Delete file"
      icon="fa-trash"
      colour="error"
      onClick={remove}
    />
  </svelte:fragment>

  <!-- whitespace-pre-wrap and a monospace face: error_message is a full Python
       traceback as of Stage 5, and collapsing its newlines makes it
       unreadable. -->
  <div class="mt-4 rounded-btn border border-error/25 bg-error/5 p-3">
    <p class="mb-1 text-xs font-medium uppercase tracking-wide text-error">
      Error message
    </p>
    <p class="whitespace-pre-wrap break-words font-mono text-sm">
      {errorMessage || "No message was recorded."}
    </p>
  </div>
</JobCard>
